import { dateFormat } from "../../utils/date";
import { currencyFormat } from "../../utils/number";

const safeDateFormat = (value) => {
    if (value === null || value === undefined || String(value).trim() === '' || value === 'null') {
        return 'N/A';
    }
    try {
        return dateFormat(value);
    } catch (e) {
        return 'Data Inválida';
    }
};

const safeTextFormat = (value) => {
    if (value === null || value === undefined || String(value).trim() === '' || value === 'null') {
        return 'N/A';
    }
    return value;
};

const formatters = {

    /** Formata uma string de data (YYYY-MM-DD) para o padrão brasileiro. */
    dateOnly: (value) => {
        if (!value || String(value).trim() === '') return 'N/A';
        try {
            const date = new Date(`${value}T00:00:00`);
            return date.toLocaleDateString('pt-BR');
        } catch (e) {
            return 'Data inválida';
        }
    },

    /** Converte valores booleanos ou strings "true"/"false" para 'Sim' ou 'Não'. */
    boolean: (value) => {
        return String(value) === 'true' ? 'Sim' : 'Não';
    }
};

// Configuração para o Dashboard (RealTime) - Rota: '/'
const realTimeConfig = {
    columns: [
        'idPedidoIntegracao',
        'idUnidade',
        'unidadeName',
        'tipoPedido',
        'tipoImportacao',
        'tipoImportacaoDescricao',
        'quantidadePessoas',
        'valorTotal',
        'pago',
        'ativo',
        'dataPedido',
        'dataImportacao',
        'dataConhecimento',
        'dataConfirmacao',
        'dataEnvio',
        'dataEntrega',
        'dataAguardandoRetirada',
        'dataCancelamento',
        'identificadorPrincipal',
        'identificadorSecundario',
        'hora',
        'dia',
        'mes',
        'ano',
        'diaSemana'
    ],
    headers: {
        idPedidoIntegracao: 'ID Pedido Integração',
        idUnidade: 'ID Unidade',
        unidadeName: 'Nome da Unidade',
        tipoPedido: 'Tipo do Pedido',
        tipoImportacao: 'Canal (Sigla)',
        tipoImportacaoDescricao: 'Canal de Venda',
        quantidadePessoas: 'Qtd. Pessoas',
        valorTotal: 'Valor Total',
        pago: 'Pago',
        ativo: 'Ativo',
        dataPedido: 'Data do Pedido',
        dataImportacao: 'Data de Importação',
        dataConhecimento: 'Data de Conhecimento',
        dataConfirmacao: 'Data de Confirmação',
        dataEnvio: 'Data de Envio',
        dataEntrega: 'Data de Entrega',
        dataAguardandoRetirada: 'Aguardando Retirada',
        dataCancelamento: 'Data de Cancelamento',
        identificadorPrincipal: 'ID Principal',
        identificadorSecundario: 'ID Secundário',
        hora: 'Hora',
        dia: 'Dia',
        mes: 'Mês',
        ano: 'Ano',
        diaSemana: 'Dia da Semana'
    },
    formatters: {
        valorTotal: currencyFormat,
        pago: formatters.boolean,
        ativo: formatters.boolean,
        dataPedido: safeDateFormat,
        dataImportacao: safeDateFormat,
        dataConhecimento: safeDateFormat,
        dataConfirmacao: safeDateFormat,
        dataEnvio: safeDateFormat,
        dataEntrega: safeDateFormat,
        dataAguardandoRetirada: safeDateFormat,
        dataCancelamento: safeDateFormat,
    }
};

// Configuração para a página de Vendas - Rota: '/sales'
const salesConfig = {
    columns: [
        'idPedido',
        'idUnidade',
        'unidadeName',
        'dataSaidaEntrada',
        'tipoPedidoDescricao',
        'tipoImportacao',
        'numeroPessoas',
        'valorTotal',
        'idPessoa',
        'nome',
        'hora',
        'dia',
        'mes',
        'ano',
        'diaSemana'
    ],
    headers: {
        idPedido: 'ID do Pedido',
        idUnidade: 'ID da Unidade',
        unidadeName: 'Nome da Unidade',
        dataSaidaEntrada: 'Data da Venda',
        tipoPedidoDescricao: 'Tipo do Pedido',
        tipoImportacao: 'Canal de Venda',
        numeroPessoas: 'Qtd. Pessoas',
        valorTotal: 'Valor Total',
        idPessoa: 'ID do Cliente',
        nome: 'Nome do Cliente',
        hora: 'Hora',
        dia: 'Dia',
        mes: 'Mês',
        ano: 'Ano',
        diaSemana: 'Dia da Semana'
    },
    formatters: {
        dataSaidaEntrada: safeDateFormat,
        valorTotal: currencyFormat,

        idPedido: safeTextFormat,
        idUnidade: safeTextFormat,
        unidadeName: safeTextFormat,
        tipoPedidoDescricao: safeTextFormat,
        tipoImportacao: safeTextFormat,
        numeroPessoas: safeTextFormat,
        idPessoa: safeTextFormat,
        nome: safeTextFormat,
        hora: safeTextFormat,
        dia: safeTextFormat,
        mes: safeTextFormat,
        ano: safeTextFormat,
        diaSemana: safeTextFormat
    }
};

// Configuração para a página de Produtos - Rota: '/product'
const productConfig = {
    columns: [
        'idUnidade',
        'unidadeName',
        'grupoProdutoDescricao',
        'tipoProduto',
        'descricao',
        'quantidade',
        'valorTotal',
        'somaNoTotal',
        'dataVendaItem',
        'dia',
        'mes',
        'ano',
        'diaSemana'
    ],
    headers: {
        idUnidade: 'ID da Unidade',
        unidadeName: 'Nome da Unidade',
        grupoProdutoDescricao: 'Grupo do Produto',
        tipoProduto: 'Tipo do Produto',
        descricao: 'Descrição do Produto',
        quantidade: 'Quantidade Vendida',
        valorTotal: 'Valor Total',
        somaNoTotal: 'Soma no Total',
        dataVendaItem: 'Data da Venda',
        dia: 'Dia',
        mes: 'Mês',
        ano: 'Ano',
        diaSemana: 'Dia da Semana'
    },
    formatters: {
        valorTotal: currencyFormat,
        somaNoTotal: formatters.boolean,
        dataVendaItem: safeDateFormat,

        idUnidade: safeTextFormat,
        unidadeName: safeTextFormat,
        grupoProdutoDescricao: safeTextFormat,
        tipoProduto: safeTextFormat,
        descricao: safeTextFormat,
        quantidade: safeTextFormat,
        dia: safeTextFormat,
        mes: safeTextFormat,
        ano: safeTextFormat,
        diaSemana: safeTextFormat
    }
};

// Configuração para a página de Clientes - Rota: '/customer'
const customerConfig = {
    columns: [
        'idUnidade',
        'idPedido',
        'idPessoa',
        'unidadeName',
        'tipoPedido',
        'tipoPedidoDescricao',
        'tipoImportacao',
        'valorTotal',
        'dataSaidaEntrada',
        'hora',
        'dia',
        'mes',
        'ano',
        'diaSemana',
        'nomeCliente',
        'telefoneCliente',
        'createdAt',
    ],
    headers: {
        idUnidade: 'ID da Unidade',
        idPedido: 'ID do Pedido',
        idPessoa: 'ID do Cliente',
        unidadeName: 'Nome da Unidade',
        tipoPedido: 'Tipo do Pedido',
        tipoPedidoDescricao: 'Descrição do Tipo do Pedido',
        tipoImportacao: 'Canal de Venda',
        valorTotal: 'Valor Total',
        dataSaidaEntrada: 'Data da Venda',
        hora: 'Hora',
        dia: 'Dia',
        mes: 'Mês',
        ano: 'Ano',
        diaSemana: 'Dia da Semana',
        nomeCliente: 'Nome do Cliente',
        telefoneCliente: 'Telefone do Cliente',
        createdAt: 'Data de Criação',
    },
    formatters: {
        idUnidade: safeTextFormat,
        idPedido: safeTextFormat,
        idPessoa: safeTextFormat,
        unidadeName: safeTextFormat,
        tipoPedido: safeTextFormat,
        tipoPedidoDescricao: safeTextFormat,
        tipoImportacao: safeTextFormat,
        valorTotal: currencyFormat,
        dataSaidaEntrada: safeDateFormat,
        hora: safeTextFormat,
        dia: safeTextFormat,
        mes: safeTextFormat,
        ano: safeTextFormat,
        diaSemana: safeTextFormat,
        nomeCliente: safeTextFormat,
        telefoneCliente: safeTextFormat,
        createdAt: safeDateFormat,
    }
}

// Configuração para exportar o detalhamento por clientes na pagina de cliente - Rota: '/customerDetails'
const customerDetailsConfig = {
    columns: [
        'idPessoa',
        'nomeCliente',
        'telefoneCliente',
        'formattedDate',
        'longevity',
        'totalValue',
        'orderQuantity',
        'averageTicket',
    ],
    headers: {
        idPessoa: 'ID da Pessoa',
        nomeCliente: 'Cliente',
        telefoneCliente: 'Telefone',
        formattedDate: 'Cliente Desde',
        longevity: 'Longevidade (dias)',
        totalValue: 'Valor Total',
        orderQuantity: 'Pedido(s)',
        averageTicket: 'Ticket Médio',
    },
    formatters: {
        idPessoa: safeTextFormat,
        nomeCliente: safeTextFormat,
        telefoneCliente: safeTextFormat,
        formattedDate: safeTextFormat,
        longevity: safeTextFormat,
        totalValue: currencyFormat,
        orderQuantity: safeTextFormat,
        averageTicket: currencyFormat,
    }
}

// Configuração para a página de Auditoria - Rota: '/checking'
const checkingConfig = {
    // mesma ordem da lista da tela; identificador é o número da comanda
    columns: [
        'unidadeName', 'identificador', 'mesa', 'produtoNome', 'quantidade', 'valorTotal',
        'dataLancamento', 'dataExclusao', 'nomeUsuarioLancamento', 'nomeUsuarioExclusao', 'observacao'
    ],
    headers: {
        unidadeName: 'Unidade',
        nomeUsuarioLancamento: 'Usuário do Lançamento',
        nomeUsuarioExclusao: 'Usuário da Exclusão',
        produtoNome: 'Produto Excluído',
        quantidade: 'Qtd.',
        valorTotal: 'Valor',
        dataExclusao: 'Data da Exclusão',
        dataLancamento: 'Data de Lançamento',
        identificador: 'Comanda',
        mesa: 'Mesa',
        observacao: 'Observação'
    },
    formatters: {
        valorTotal: currencyFormat,
        dataExclusao: safeDateFormat,
        dataLancamento: safeDateFormat
    }
};

// Configuração para a página de Auditoria: Pedidos não importados - Rota: '/orderIntegration'
const orderIntegrationConfig = {
    columns: [
        'idPedidoIntegracao', 'unidadeName', 'tipoPedido', 'tipoImportacaoDescricao', 'valorTotal',
        'dataPedido', 'dataImportacao', 'dataCancelamento', 'identificadorPrincipal', 'pago'
    ],
    headers: {
        idPedidoIntegracao: 'ID do pedido',
        unidadeName: 'Unidade',
        tipoPedido: 'Tipo do pedido',
        tipoImportacaoDescricao: 'Origem',
        valorTotal: 'Valor',
        dataPedido: 'Data do pedido',
        dataImportacao: 'Data da importação',
        dataCancelamento: 'Data do cancelamento',
        identificadorPrincipal: 'Identificador',
        pago: 'Pago'
    },
    formatters: {
        valorTotal: currencyFormat,
        dataPedido: safeDateFormat,
        dataImportacao: safeDateFormat,
        dataCancelamento: safeDateFormat,
        pago: formatters.boolean
    }
};

// Configuração para a página de Auditoria: Exclusões de pagamentos - Rota: '/paymentExclusion'
const paymentExclusionConfig = {
    columns: [
        'idPedido', 'unidadeName', 'nomeUsuario', 'usernameUsuario', 'dataHoraEvento',
        'tipo', 'entidade', 'motivo', 'valor', 'formaPagamento'
    ],
    headers: {
        idPedido: 'ID do pedido',
        unidadeName: 'Unidade',
        nomeUsuario: 'Usuário',
        usernameUsuario: 'Login do usuário',
        dataHoraEvento: 'Data',
        tipo: 'Tipo',
        entidade: 'Entidade',
        motivo: 'Motivo',
        valor: 'Valor',
        formaPagamento: 'Forma de pagamento'
    },
    formatters: {
        dataHoraEvento: safeDateFormat,
        valor: currencyFormat
    }
};

/**
 * Retorna o objeto de configuração de exportação com base no pathname da URL.
 * @param {string} pathname A rota atual (ex: '/sales').
 * @returns {Object} O objeto de configuração para o hook useExport.
 */
export function getExportConfig(pathname) {
    switch (pathname) {
        case '/':
            return realTimeConfig;
        case '/sales':
            return salesConfig;
        case '/product':
            return productConfig;
        case '/customer':
            return customerConfig
        case '/customerDetails':
            return customerDetailsConfig
        case '/checking':
            return checkingConfig;
        case '/orderIntegration':
            return orderIntegrationConfig;
        case '/paymentExclusion':
            return paymentExclusionConfig;
        default:
            return {};
    }
}